<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let errorName: string;
  export let form: any;

</script>

{#if $form.hasError(errorName)}
  <p class="fizz-flex-row-4 fizz-text-urgent fizz-text-medium fizz-text-regular">
    <Icon type="Error" height={20} width={16} />
    <span><slot /></span>
  </p>
{/if}
